import { css, keyframes } from "@emotion/core";
import { OVERLAY_ZINDEX, OVERLAY_CSS } from "shared/styles/base";
import { resetButton } from "shared/styles/mixin";

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translate(-50%, -150%);
    }

    to {
        opacity: 1;
        transform: translate(-50%, -51.5%);
    }
`;

const slideOut = keyframes`
    from {
        opacity: 1;
        transform: translate(-50%, -51.5%);
    }

    to {
        opacity: 0;
        transform: translate(-50%, -150%);
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
`;

export const modalCss = css`
    position: fixed;
    left: -999px;
    max-width: 90%;
    max-height: 90%;
    background: #fff;
    border-radius: 2px;
    animation: ${slideIn} 0.25s ease-in forwards;
    z-index: ${OVERLAY_ZINDEX + 10};
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 30px 6px rgba(0, 0, 0, 0.15);
    overflow-y: auto;

    &.show-modal {
        top: 50%;
        left: 50%;
        animation: ${slideIn} 0.25s ease-in forwards;
    }

    ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
    }

    .icon-cross {
        ${resetButton}

        position: absolute;
        right: 15px;
        top: 25px;
        padding: 10px;
        cursor: pointer;
        font-size: 1.57rem;
        z-index: 10010;
    }
`;

export const modalHide = css`
    top: 50%;
    left: 50%;
    animation: ${slideOut} 0.2s ease-out forwards;
`;

export const overlayCss = OVERLAY_CSS;

export const zIndex = css`
    z-index: ${OVERLAY_ZINDEX + 9};
`;

export const overlayHide = css`
    animation: ${fadeOut} 0.2s ease-out forwards;
`;
